var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DashboardLayout',{attrs:{"menu-items":_vm.storeDashboardMenu}},[_c('dashboard-mobile-profile'),_c('div',{staticClass:"text-dashboard p-0 w-100 h-auto"},[_c('m-update-site-message-1'),_c('router-view',{attrs:{"name":"dashboard"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }